import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { Price } from 'src/components/calendar/BuyTickets/Price'
import { TicketButton } from 'src/components/calendar/BuyTickets/TicketButton'

const style = require('./TicketNav.css')


interface Props {
  eventData: any,
  viewer: any,
  baseUrl: string,
  listingStatus: string,
  ticketButtonText: string,
  isTimedEntry: boolean,
  eventOpen: boolean,
  expanded: boolean,
  loading: boolean,
  eventSoldOut: boolean,
}

const currentTime = new Date().getTime() / 1000

export const TicketNavComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  baseUrl,
  loading,
  viewer,
  listingStatus,
  ticketButtonText,
  isTimedEntry,
  intl: { formatMessage },
}) => {

  if (loading) return null

  return (
    <div className={style.container}>
      <div>
        <Price
          minPrice={eventData.minPrice}
          maxPrice={eventData.maxPrice}
          currency={eventData.transactionCurrency}
          listingStatus={listingStatus}
        />
      </div>
      <TicketButton
        listingStatus={listingStatus}
        ticketButtonText={ticketButtonText}
        isTimedEntry={isTimedEntry}
        eventId={eventData.id}
        baseUrl={baseUrl}
        hostId={eventData.hostId}
        viewer={viewer}
      />
    </div>
  )
}

export const TicketNav = injectIntl(TicketNavComponent)
